import React from 'react';
import { FooterLink } from '@ui/components/atoms';
import { useTranslate } from '@translations/useTranslate';
import { Translations } from '@translations/translationsTypes';
import FooterLinksContainerStyles from './FooterLinksContainer.module.scss';

type Props = {
  links: { title: string; titleAr: string; link: string; linkAr: string }[];
};

export const FooterLinksContainer: React.FC<Props> = ({ links }) => {
  const { language } = useTranslate();
  return (
    <div className={FooterLinksContainerStyles.footer_links_container}>
      {links.map((link, index) => (
        <FooterLink
          key={`footer-link-${index}`}
          title={language === Translations.ar ? link.titleAr : link.title}
          link={language === Translations.ar ? link.linkAr : link.link}
        />
      ))}
    </div>
  );
};
